import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mergeMap } from "rxjs/operators";
import { ConfigService } from '../../../config/config.service';
import { Client } from '../../shared/client/client';
import { Contact } from './contact';

@Injectable({
  providedIn: 'root'
})
export class SavService {

  constructor(
    private configService: ConfigService,
    private http: HttpClient
  ) { }

  getSavDefault(client: Client): Observable<Contact> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Contact>(config.apiPoint + config.getClientSavDefault.replace('{client}', client.id));
      })
    );
  }

  askRdv(client, askForm: any): Observable<any> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.post<Observable<any>>(config.apiPoint + config.getClientContactSend.replace('{client}', client.id), askForm);
      }));
  }
}
